export enum RadioButtonColor {
  Default = "Default",
  AccentOrange = "AccentOrange",
}

export enum UncheckedRadioButtonColor {
  Default = "Default",
  LightGray = "LightGray",
}
